export default "__VITE_ASSET__DMV16K67__"